import { Routes } from '@angular/router';

export const CommonLayout_ROUTES: Routes = [
    {
        path: 'admin',
        loadChildren: () => import('../../admin/admin.module')
            .then(m => m.AdminModule)
    },
    {
        path:'panel',
        loadChildren: () => import('../../pages/indicators/indicators.module')
            .then(m => m.IndicatorsModule)
    },
    {
        path:'reports',
        loadChildren: () => import('../../pages/reports/reports.module')
            .then(m => m.ReportsModule)

    },
    {
        path:'financial-situation',
        loadChildren: () =>
            import('../../pages/financial-situation/financial-situation.module')
            .then(m => m.FinancialSituationModule)
    },
    {
        path:'indicators',
        loadChildren: () => import('../../pages/indicators/indicators.module')
            .then(m => m.IndicatorsModule)
    },
    {
        path:'reconciliations',
        loadChildren: () =>
            import('../../pages/reconciliations/reconciliations.module')
            .then(m => m.ReconciliationsModule)
    },
    {
        path: 'clients-suppliers',
        loadChildren: () =>
            import('../../pages/clients-suppliers/clients-suppliers.module')
            .then(m => m.ClientsSuppliersModule)
    },
    {
        path:'settings',
        loadChildren: () => import('../../pages/settings/settings.module')
            .then(m => m.SettingsModule)

    },
    {
        path:'consistency-reports',
        loadChildren: () =>
            import('../../pages/consistency-reports/consistency-reports.module')
            .then(m => m.ConsistencyReportsModule)

    },
    {
        path:'accounting-software-integration',
        loadChildren: () =>
            import('../../pages/accounting-software-integration/accounting-software-integration.module')
            .then(m => m.AccountingSoftwareIntegrationModule)
    },
    {
        path:'ondemand',
        loadChildren: () =>
            import('../../pages/ondemand/ondemand.module')
            .then(m => m.OndemandModule)
    },
    {
        path:'remunerations',
        loadChildren: () =>
            import('../../pages/remunerations/remunerations.module')
            .then(m => m.RemunerationsModule)
    }
];